export enum LoggedColumn {
    LogFile = "logFile",
    LineNumber = "lineNumber"
}